var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-container" },
    [
      _c(
        "BjDrawerForm",
        {
          ref: "BjDrawerForm",
          attrs: {
            form: _vm.form,
            rules: _vm.rules,
            confirmDis: _vm.openType == "view",
            width: "720px",
            "label-width": "120px",
          },
          on: { handleConfirm: _vm.handleConfirm, close: _vm.handleClose },
        },
        [
          _c("BjDivider", [_vm._v(_vm._s(_vm.$t("CustomerFunction.company")))]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.companyName"),
                        prop: "companyName",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("billingPage.companyName"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.companyName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "companyName", $$v)
                          },
                          expression: "form.companyName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("toolsProfit.industry"),
                        prop: "industry",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          placeholder: _vm.$t("toolsProfit.industry"),
                          "option-list": _vm.USER_ONBOARDING_INDUSTRY_LIST,
                        },
                        model: {
                          value: _vm.form.industry,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "industry", $$v)
                          },
                          expression: "form.industry",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "ABN", prop: "abn" } },
                    [
                      _c("BjInput", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: "ABN",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.abn,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "abn", $$v)
                          },
                          expression: "form.abn",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.CustomerType"
                        ),
                        prop: "customerType",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          placeholder: _vm.$t(
                            "AccountManagementAdd.customerInfo.CustomerType"
                          ),
                          "option-list": _vm.USER_CUSTOMER_TYPE_LIST,
                        },
                        model: {
                          value: _vm.form.customerType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "customerType", $$v)
                          },
                          expression: "form.customerType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan * 2 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CustomerFunction.website"),
                        prop: "website",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("CustomerFunction.website"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.website,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "website", $$v)
                          },
                          expression: "form.website",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("BjDivider", [_vm._v(_vm._s(_vm.$t("CustomerFunction.contact")))]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CustomerFunction.person"),
                        prop: "primaryContactPerson",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("CustomerFunction.person"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.primaryContactPerson,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "primaryContactPerson", $$v)
                          },
                          expression: "form.primaryContactPerson",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CustomerFunction.phone"),
                        prop: "phone",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("CustomerFunction.phone"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.GeneralEmail"
                        ),
                        prop: "email",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t(
                            "AccountManagementAdd.customerInfo.GeneralEmail"
                          ),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "email", $$v)
                          },
                          expression: "form.email",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.BillEmail"
                        ),
                        prop: "billingAddressEmail",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t(
                            "AccountManagementAdd.customerInfo.BillEmail"
                          ),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.billingAddressEmail,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "billingAddressEmail", $$v)
                          },
                          expression: "form.billingAddressEmail",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan * 2 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CustomerFunction.address"),
                        prop: "businessAddress",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("CustomerFunction.address"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.businessAddress,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "businessAddress", $$v)
                          },
                          expression: "form.businessAddress",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("BjDivider", [
            _vm._v(_vm._s(_vm.$t("CustomerFunction.business"))),
          ]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.ifLocal"
                        ),
                        prop: "ifLocal",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          "option-list": _vm.STATUS_YES_TRUE,
                          placeholder: _vm.$t(
                            "AccountManagementAdd.customerInfo.ifLocal"
                          ),
                        },
                        model: {
                          value: _vm.form.ifLocal,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "ifLocal", $$v)
                          },
                          expression: "form.ifLocal",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.currencySymbol"
                        ),
                        prop: "currencySymbol",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          "lov-code": "CHANNEL_CURRENCY",
                          placeholder: _vm.$t(
                            "AccountManagementAdd.customerInfo.currencySymbol"
                          ),
                        },
                        model: {
                          value: _vm.form.currencySymbol,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "currencySymbol", $$v)
                          },
                          expression: "form.currencySymbol",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CustomerFunction.sku"),
                        prop: "skuVolume",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("CustomerFunction.sku"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.skuVolume,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "skuVolume", $$v)
                          },
                          expression: "form.skuVolume",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CustomerFunction.model"),
                        prop: "businessModel",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          "option-list": [
                            { label: "B2B", value: "B2B" },
                            { label: "B2C", value: "B2C" },
                          ],
                          multiple: "",
                          collapseTags: false,
                          placeholder: _vm.$t("CustomerFunction.model"),
                        },
                        model: {
                          value: _vm.form.businessModel,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "businessModel", $$v)
                          },
                          expression: "form.businessModel",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.billingAddress"
                        ),
                        prop: "billingAddress1",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t(
                            "AccountManagementAdd.customerInfo.billingAddress"
                          ),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.billingAddress1,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "billingAddress1", $$v)
                          },
                          expression: "form.billingAddress1",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CustomerFunction.start"),
                        prop: "expectedStartDate",
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticClass: "full-width",
                        attrs: {
                          disabled: _vm.openType == "view",
                          format: "dd/MM/yyyy",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          type: "datetime",
                          placeholder: _vm.$t("CustomerFunction.start"),
                        },
                        model: {
                          value: _vm.form.expectedStartDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "expectedStartDate", $$v)
                          },
                          expression: "form.expectedStartDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CustomerFunction.FreightMargin"),
                        prop: "freightMargin",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          max: 100,
                          min: 0,
                          precision: 0,
                          "not-auto-zero": true,
                          placeholder: _vm.$t("CustomerFunction.FreightMargin"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.freightMargin,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "freightMargin", $$v)
                          },
                          expression: "form.freightMargin",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CustomerFunction.payment"),
                        prop: "paymentMode",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          "option-list": _vm.paymentList,
                          placeholder: _vm.$t("CustomerFunction.payment"),
                        },
                        on: { change: _vm.clearForm },
                        model: {
                          value: _vm.form.paymentMode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "paymentMode", $$v)
                          },
                          expression: "form.paymentMode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.paymentMode != 1
                ? _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CustomerFunction.PaymentTerm"),
                            prop: "paymentTerm",
                          },
                        },
                        [
                          _c("BjInputNumber", {
                            attrs: {
                              disabled: _vm.openType == "view",
                              max: 100,
                              min: 0,
                              precision: 0,
                              "not-auto-zero": true,
                              placeholder: _vm.$t(
                                "CustomerFunction.PaymentTerm"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.paymentTerm,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "paymentTerm", $$v)
                              },
                              expression: "form.paymentTerm",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.paymentMode == 2
                ? _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CustomerFunction.CreditLimit"),
                            prop: "creditLimit",
                          },
                        },
                        [
                          _c("BjInputNumber", {
                            attrs: {
                              disabled: _vm.openType == "view",
                              max: 10000000,
                              min: 0,
                              precision: 2,
                              "not-auto-zero": true,
                              placeholder: _vm.$t(
                                "CustomerFunction.CreditLimit"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.creditLimit,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "creditLimit", $$v)
                              },
                              expression: "form.creditLimit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.paymentMode == 3
                ? _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CustomerFunction.BondLimit"),
                            prop: "bondLimit",
                          },
                        },
                        [
                          _c("BjInputNumber", {
                            attrs: {
                              disabled: _vm.openType == "view",
                              max: 10000000,
                              min: 0,
                              precision: 2,
                              "not-auto-zero": true,
                              placeholder: _vm.$t("CustomerFunction.BondLimit"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.bondLimit,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bondLimit", $$v)
                              },
                              expression: "form.bondLimit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.paymentMode != 1
                ? _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CustomerFunction.NETEOM"),
                            prop: "isMb",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              disabled: _vm.openType == "view",
                              "option-list": _vm.isMbList,
                              placeholder: _vm.$t("CustomerFunction.NETEOM"),
                            },
                            model: {
                              value: _vm.form.isMb,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "isMb", $$v)
                              },
                              expression: "form.isMb",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CustomerFunction.PalletText"),
                        prop: "estimationPalletQty",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          placeholder: _vm.$t("CustomerFunction.PalletText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.estimationPalletQty,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "estimationPalletQty", $$v)
                          },
                          expression: "form.estimationPalletQty",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CustomerFunction.WeeklySalesText"),
                        prop: "estWeeklyRevenue",
                      },
                    },
                    [
                      _c("BjInputMoney", {
                        attrs: {
                          disabled: _vm.openType == "view",
                          placeholder: _vm.$t(
                            "CustomerFunction.WeeklySalesText"
                          ),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.estWeeklyRevenue,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "estWeeklyRevenue", $$v)
                          },
                          expression: "form.estWeeklyRevenue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("BjDivider", [
            _vm._v(_vm._s(_vm.$t("CustomerFunction.onboardingFiles"))),
          ]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c("el-button", { on: { click: _vm.openSelectFile } }, [
                    _vm._v(_vm._s(_vm.$t("fileSearch.page.FileUpload"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("fileSearch.page.FileUpload"),
            visible: _vm.dialogVisible,
            width: "666px",
            "before-close": _vm.handleCancel,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dialogForm",
              staticClass: "bj-query-form bj-query-form-for-cal-height",
              attrs: {
                model: _vm.dialogForm,
                "label-width": "170px",
                "label-position": "left",
              },
            },
            [
              _c(
                "el-row",
                _vm._l(_vm.fileTitleList, function (item, index) {
                  return _c(
                    "el-col",
                    { key: index },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { position: "relative" },
                          attrs: { label: item + " : " },
                        },
                        [
                          _c(
                            "UploadFile",
                            {
                              ref: "UploadFileRef" + index,
                              refInFor: true,
                              staticClass: "avatar-uploader",
                              attrs: {
                                "limit-size": 5 * 1024,
                                "show-file-list": "",
                                disabled: _vm.openType == "view",
                                accept:
                                  index == "3"
                                    ? "image/png,image/jpeg,"
                                    : index == "5"
                                    ? ".eml,.pdf"
                                    : ".pdf",
                                "auto-upload": "",
                                "limit-hide": "",
                              },
                              on: {
                                handleFileListChange: function ($event) {
                                  return _vm.fileListChange($event, item)
                                },
                              },
                            },
                            [
                              _c("template", { slot: "default" }, [
                                _c(
                                  "div",
                                  { staticClass: "flex-align" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          disabled: _vm.openType == "view",
                                          size: "small",
                                          type: "primary",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "BusinessImportHistory.page.SelectFile"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            2
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                position: "absolute",
                                top: "1px",
                                left: "100px",
                              },
                              attrs: {
                                disabled: _vm.disabledDown(item),
                                size: "small",
                                type: "primary",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.downloadOnboardingFile(item)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("downloadText")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.openType == "view", type: "primary" },
                  on: { click: _vm.handleSend },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }